import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/modal';
import Typography from '../../Typography';
import Button from '../../Button';
import { Checkbox, Input } from '@nextui-org/react';
import React from 'react';
import { areAllNotEmpty } from '../../../../../helpers/utils';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/reducer-main';
import { updateCustomerData } from '../../../../../service/common/stripe';
import { toast } from 'react-toastify';
import { updateStripeCustomerData } from '../../../../../store/profile/slice';

interface Props{
    billsDataModal:any
}

export default function ModifyBillsDataModalContent({billsDataModal}:Props) {

    const dispatch= useDispatch()
    const { userProfile,paymentMethod } = useSelector((state: StoreState) => state.profile);

        
    const [loading,setLoading]=React.useState<boolean>(false)
    const [checkbox,setCheckbox]=React.useState<boolean>(false)
    const [name,setName]=React.useState<string>("")
    const [surname,setSurname]=React.useState<string>("")
    const [postalCode,setPostalCode]=React.useState<string>("")
    const [address,setAddress]=React.useState<string>("")
    const [city,setCity]=React.useState<string>("")
    const [registeredBusinessName,setRegisteredBusinessName]=React.useState<string>("")
    const [vatNumber,setVatNumber]=React.useState<string>("")
    const [SDI,setSDI]=React.useState<string>("")
    
    const onSubmit= async()=>{
        if(!userProfile) return 
        try {
            setLoading(true)
            const updateCustomerDataResponse=await updateCustomerData({
                stripeCustomerId: userProfile?.stripeCustomer.id,
                data: {
                    name,
                    surname,
                    postalCode,
                    isCompany:checkbox,
                    address:address+", "+ city,
                    city,
                    vatNumber:vatNumber,
                    companyName: registeredBusinessName,
                    sdi: SDI,
                }
            })
            dispatch(updateStripeCustomerData(updateCustomerDataResponse))
            billsDataModal.onOpenChange()
            console.log("😍😍",updateCustomerDataResponse)
            toast.success("Dati di fatturazione modificati con successo!")
            setLoading(false)
        } catch (error) {
            toast.error("Errore nella modifica dei dati di fatturazione")
            setLoading(false)
            console.log(error)
        }
    }

    const onCheckBoxChange=()=>{
        if(checkbox)return
        setRegisteredBusinessName("")
        setVatNumber("")
        setAddress("")
        setCity("")
        setSDI("")
    }


    return (
      <div className='my-4 '>
        <Input onChange={(e)=>setName(e.target.value)} value={name} className='my-5' placeholder='Nome'/>
        <Input onChange={(e)=>setSurname(e.target.value)} value={surname} className='my-5' placeholder='Cognome'/>
        <Input onChange={(e)=>setAddress(e.target.value)} value={address} className='my-5' placeholder='Indirizzo'/>
        <div className=" my-5 flex gap-5">
            <Input onChange={(e)=>setCity(e.target.value)} value={city}  placeholder='Città'/>
            <Input onChange={(e)=>setPostalCode(e.target.value)} value={postalCode}  placeholder='CodicePostale'/>
        </div>
        <div className=" my-6 flex gap-3 items-center">
            <Checkbox onChange={onCheckBoxChange} onClick={()=>setCheckbox(!checkbox)} isSelected={checkbox} color="primary" />
            <Typography variant="label">Sono un'azienda</Typography>
        </div>
        <Input style={{opacity:!checkbox?0.2:1}} disabled={!checkbox} onChange={(e)=>setRegisteredBusinessName(e.target.value)} value={registeredBusinessName} className='my-5' placeholder='Ragione Sociale'/>
        <Input style={{opacity:!checkbox?0.2:1}} disabled={!checkbox} onChange={(e)=>setVatNumber(e.target.value)} value={vatNumber} className='my-5' placeholder='Partita Iva'/>
        <Input style={{opacity:!checkbox?0.2:1}} disabled={!checkbox} onChange={(e)=>setSDI(e.target.value)} value={SDI} className='my-5' placeholder='SDI'/>
        <div className='flex justify-center mt-10 mb-5'>
            <Button disabled={
                loading ||(checkbox?
                !areAllNotEmpty([name,surname,postalCode,registeredBusinessName,vatNumber,address,city,SDI,]):
                !areAllNotEmpty([name,surname,postalCode,address,city]))
                 }
                  style={{flex:1}} onClick={()=>{onSubmit()}} variant="secondary" colorVariant='primary' title='AGGIORNA'/>
        </div>
      </div>  
    );
 }
